import { render, staticRenderFns } from "./page-settings-modal.vue?vue&type=template&id=00f97a40&scoped=true"
import script from "./page-settings-modal.vue?vue&type=script&lang=js"
export * from "./page-settings-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f97a40",
  null
  
)

export default component.exports